module.exports = __webpack_public_path__ + "static/img/passwordchange.1401acf.png";